<template>
  <div>
    <router-link class="come-back" to="/admin/page">
      <div></div>
      Вернуться назад
    </router-link>

    <h2 class="title_categories">
      {{ isEdit ? `Редактирование страницы №${$route.params.id}` : 'Создание страницы' }}
    </h2>
    <tricolor-line class="card_containet__tricolor"/>

    <form @submit.prevent="createPage" ref="createPage">
      <div class="content-sb">
        <p>Секция<span>*</span></p>
        <select name="rubric" v-model="pageData.section_id" class="input blue">
          <option v-for="(section,index) in getSection" :value="section.id" :key="`section${index}`">
            {{ section.title }}
          </option>
        </select>
      </div>

        <div class="content-sb">
          <p>Заголовок<span>*</span></p>
          <input required placeholder="Введите заголовок" v-model="pageData.title" type="text" name="title" class="input blue">
        </div>

        <div class="content-sb">
          <p>Заголовок (Англ.)</p>
          <input placeholder="Введите заголовок (Англ.)" v-model="pageData.title_eng" type="text" name="title_eng" class="input blue">
        </div>

        <div class="content-sb">
          <p>Приоритет<span>*</span></p>
          <input required v-model="pageData.order" type="number" name="order" class="input blue">
        </div>

        <div class="content-sb">
          <p>Главная?<span>*</span></p>
          <input v-model="pageData.is_main" type="checkbox" name="is_main" class="input blue">
        </div>

        <div class="content-sb">
          <p>Активна?<span>*</span></p>
          <input v-model="pageData.is_visible" type="checkbox" name="is_visible" class="input blue">
        </div>

      <div class="content-sb">
        <p>Контент<span>*</span></p>
        <ckeditor :config="$editorConfig" :editor-url="$root.editorUrl" v-model="pageData.content"></ckeditor>
      </div>

      <div class="content-sb">
        <p>Контент (Англ.)</p>
        <ckeditor :config="$editorConfigEng" :editor-url="$root.editorUrl" v-model="pageData.content_eng"></ckeditor>
      </div>

      <footer class="content-sb btns-create-form">
        <router-link to="/admin/page" class="btn-white">Отмена</router-link>
        <input type="submit" class="btn-blue" value="Сохранить"/>
      </footer>
    </form>
  </div>
</template>

<script>
import TricolorLine from '@/components/TricolorLine'

export default {
  name: 'createPage',

  props: {
    isEdit: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  data () {
    return {
      pageData: {
        section_id: null,
        title: null,
        title_eng: '',
        content: '',
        content_eng: '',
        is_main: false,
        is_visible: true,
        order: 1
      }
    }
  },

  watch: {
    '$store.getters.getDetailedPage' () {
      const dataFromServer = this.$store.getters.getDetailedPage

      this.pageData = {
        section_id: dataFromServer.section_id,
        title: dataFromServer.title,
        title_eng: dataFromServer.title_eng ?? '',
        content: dataFromServer.content,
        content_eng: dataFromServer.content_eng,
        is_main: dataFromServer.is_main,
        is_visible: dataFromServer.is_visible,
        order: dataFromServer.order
      }
      this.$forceUpdate()
    }
  },

  created () {
    if (this.isEdit) {
      this.$store.dispatch('setDetailedPage', this.$route.params.id)
    }
    this.$store.dispatch('setSection')
  },

  methods: {
    createPage () {
      const formData = new FormData()
      formData.append('section_id', this.pageData.section_id)
      formData.append('title', this.pageData.title)
      formData.append('title_eng', this.pageData.title_eng)
      formData.append('content', this.pageData.content)
      formData.append('content_eng', this.pageData.content_eng)
      formData.append('is_main', this.pageData.is_main)
      formData.append('is_visible', this.pageData.is_visible)
      formData.append('order', this.pageData.order)

      if (!this.isEdit) {
        this.$store.dispatch('createPage', formData)
      } else {
        formData.append('_method', 'PUT')
        this.$store.dispatch('editPage', {
          data: formData,
          id: this.$route.params.id
        })
      }
    }
  },
  computed: {
    getSection () {
      return this.$store.getters.getAdminSection
    }
  },
  components: {
    TricolorLine
  }
}
</script>

<style scoped lang="scss">
  @import "../../../assets/scss/utils/vars";

  .wysiwyg {
    width: 33.75rem;
  }

  .contacts__block {
    border-bottom: 1px solid #D5D6D9;
    margin-bottom: 1rem;

    header {
      margin-bottom: .75rem;
      display: flex;
      justify-content: space-between;
      align-items: center;

      > h4 {
        font-size: .875rem;
        line-height: 1.375rem;
      }

      > img {
        width: 1.5rem;
        height: 1.5rem;
        object-fit: contain;
        object-position: center;
        cursor: pointer;
      }
    }
  }

  .btns-create-form {
    border-top: 1px solid #D5D6D9;
    padding-top: 2.5rem;
    margin-top: 2.5rem;
  }

  .content-sb {
    margin-bottom: 1.25rem;

    span {
      color: red;
    }
  }

  .select, .input {
    width: 33.75rem;
  }

  .inputs__container {
    margin-bottom: 2rem;
    border-bottom: 1px solid #D5D6D9;
  }

  .content-blocks__container {
    display: flex;
    flex-direction: column;

    > .content-block {
      margin-bottom: 1.875rem;

      header {
        margin-bottom: .75rem;
        display: flex;
        justify-content: space-between;
        align-items: center;

        > h4 {
          font-size: .875rem;
          line-height: 1.375rem;
          color: $mainFontColor;
        }

        > img {
          width: 1.5rem;
          height: 1.5rem;
          object-fit: contain;
          object-position: center;
          cursor: pointer;
        }
      }

      .data-card {
        background: white;
        border: 1px solid #EBF3FF;
        box-sizing: border-box;
        box-shadow: 0 .9375rem 1.5625rem rgba(189, 205, 221, 0.15);
        border-radius: .5rem;
        padding: 1.25rem;
        width: 100%;
        min-height: 8.875rem;
      }
    }
  }

  .add-content-block__container {
    background-color: $neutral-placeholder;
    width: 100%;
    padding: 1.25rem;
    border-radius: .187rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    margin-top: .5rem;

    &:after {
      content: '';
      position: absolute;
      width: 1.5rem;
      height: 1.5rem;
      background-color: $neutral-placeholder;
      top: 0;
      left: 50%;
      transform: translate(-50%,-50%) rotate(45deg);
    }

    > .row {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 1.25rem;
    }

    > .btn-blue > img {
      width: 1.125rem;
      height: 1.125rem;
      object-fit: contain;
      object-position: center;
      margin-right: .5rem;
    }
  }
</style>
